import React from "react"
import {FORMAT_TEXT_COMMAND, LexicalEditor} from "lexical"
import ControlButtonStandard from "../../../../../buttons/control-button/control-button-standard"
import PopupMenuButton from "../../../../../popover-menu/popup-menu-button/popup-menu-button"
import ToolbarStylesButton from "./styles-button"
import ToolbarStylesMenu from "./styles-menu"
import ColorToolbarSelector from "../combined/color-selector/color-selector";
import {FontColorType} from "../../../highlight/font-color/font-color-plugin";
import {BadgeType} from "../../../highlight/badge/badge-plugin";

type Props = {
    editor          : LexicalEditor
    isBold          : boolean
    isItalic        : boolean
    isUnderline     : boolean

    isCode          : boolean
    isStrikethrough : boolean
    isSubscript     : boolean
    isSuperscript   : boolean

    fontColorType?  : FontColorType | null
    badgeType?      : BadgeType | null
}

export default function StylesToolbar(props: Props): JSX.Element {
    const onClickBold       = () => props.editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold')
    const onClickItalic     = () => props.editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic')

    return (
        <>
            <ControlButtonStandard  iconClass   = "editor-i5-bold fs-16"
                                    isSelected  = {props.isBold}
                                    onClick     = {onClickBold}/>

            <ControlButtonStandard  iconClass   = "editor-i5-italic fs-16"
                                    isSelected  = {props.isItalic}
                                    onClick     = {onClickItalic}/>

            <ColorToolbarSelector editor        = {props.editor}
                                  fontColorType = {props.fontColorType}
                                  badgeType     = {props.badgeType}/>

            <PopupMenuButton hint           = "Inline style options"
                             btnComponent   = {ToolbarStylesButton}
                             menuComponent  = {ToolbarStylesMenu}
                             menuParams     = {{
                                 isUnderline    : props.isUnderline,
                                 isCode         : props.isCode,
                                 isStrikethrough: props.isStrikethrough,
                                 isSubscript    : props.isSubscript,
                                 isSuperscript  : props.isSuperscript,
                                 editor         : props.editor
                             }}/>
        </>
    )
}